<template>
  <div class="account_layout">
    <router-view />
  </div>
</template>

<script>
export default {
  created () {
    this.htmlEl = document.documentElement
    this.bodyEl = document.body
    this.htmlEl.classList.add('wrap_thumb')
    this.bodyEl.classList.add('body_thumb')
  },
  destroyed () {
    this.htmlEl.classList.remove('wrap_thumb')
    this.bodyEl.classList.remove('body_thumb')
  }
}
</script>

<style lang="scss">
.body_thumb {
  #app {
    min-width: 0;
  }
  .account_layout {
    width: 100%;
    height: 100%;
  }
}
</style>
